export default __webpack_public_path__ + "static/media/grasp_and_place.91eec18f.png";